module.exports = __webpack_public_path__ + "img/introduce1.66ac03bf.png";